module.exports = __webpack_public_path__ + "img/avatar.465b890b.png";